/**
 * Created by CCristi on 11/14/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractStrategy = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _deepCore = require('deep-core');

var _deepCore2 = _interopRequireDefault(_deepCore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let AbstractStrategy = exports.AbstractStrategy = function (_Core$OOP$Interface) {
  _inherits(AbstractStrategy, _Core$OOP$Interface);

  function AbstractStrategy() {
    _classCallCheck(this, AbstractStrategy);

    return _possibleConstructorReturn(this, (AbstractStrategy.__proto__ || Object.getPrototypeOf(AbstractStrategy)).call(this, ['onSuccess', 'onError']));
  }

  /**
   * @param {Response} response
   * @returns {Boolean}
   */


  _createClass(AbstractStrategy, [{
    key: 'decide',
    value: function decide(response) {
      return this[response.isError ? 'onError' : 'onSuccess'](response);
    }
  }]);

  return AbstractStrategy;
}(_deepCore2.default.OOP.Interface);


//////////////////
// WEBPACK FOOTER
// ../~/deep-resource/lib.compiled/Resource/RetryStrategy/AbstractStrategy.js
// module id = 68
// module chunks = 0